<template>
  <div>
    <b-card>
      <b-row class="mb-1">
        <b-col class="col-md-7">
          <h2 class="text-blue font-weight-bold col-md-10 col-lg-10 col-xl-11 mt-1">
            {{ $t("referral_program") }}
          </h2>
        </b-col>

        <b-col class="col-md-5">
          <div class="d-flex align-items-center justify-content-end ml-auto">
            <b-button variant="primary" @click="$router.push('/referral-program/settings')">
              {{ $t("settings") }}
            </b-button>
          </div>
        </b-col>
      </b-row>

      <Table
          :url="url"
          :fields="fields"
          :key="tableKey"
          striped
          responsive
          hover
          class="position-relative"
          show-empty
      >
        <template #cell(name)="data">
          <p class="badge badge-light-primary" style="max-width: 400px; white-space: normal; word-wrap: break-word; overflow-wrap: break-word;"
             @click="$router.push(`/referral-program/${data.item.id}`)" role="button">
            {{ getReferrerName(data.item) }}
          </p>
        </template>

        <template #cell(companies)="data">
            <span v-if="parseCompanies(data.item.companies).length">
              {{
                parseCompanies(data.item.companies)
                    .map(company => company.company_name ? company.company_name : `C-${company.company_id}`)
                    .join(', ')
              }}
            </span>
          <span v-else>-</span>
        </template>

        <template #cell(code)="data">
          <p class="badge badge-light-primary" role="button" @click="copyLink(data.item)">
            {{ data.item.rrp_link }}
          </p>
        </template>

        <template #cell(collected_hive_fee)="data">
          <p>
            {{ data.item.rrp_link }}
          </p>
        </template>

        <template #cell(status)="data">
          <b-badge :variant="data.item.status === 'Completed' ? 'light-success' : 'light-warning'">
            {{ $t(data.item.status.toLowerCase()) }}
          </b-badge>
        </template>

        <template #cell(actions)="data">
          <div style="min-width: 180px">
            <b-button variant="outline-primary"
                      size="sm" class="mr-1"
                      v-b-tooltip.hover
                      :title="$t('details')"
                      @click="$router.push(`/referral-program/${data.item.id}`)"
            >
              <feather-icon icon="FileTextIcon"/>
            </b-button>

            <b-button v-if="adminType(['super_admin','admin_type_a']) && amountIsNotEmpty(data.item)"
                      size="sm"
                      class="mr-1"
                      v-b-tooltip.hover
                      :title="$t('confirm')"
                      variant="outline-success"
                      @click="openModal('confirm', data.item)"
            >
              <feather-icon icon="CheckIcon"/>
            </b-button>

            <b-button v-if="adminType(['super_admin']) && amountIsNotEmpty(data.item)"
                      size="sm"
                      class="mr-1"
                      v-b-tooltip.hover
                      :title="$t('cancel')"
                      variant="outline-danger"
                      @click="openModal('cancel', data.item)"
            >
              <feather-icon icon="XIcon"/>
            </b-button>
          </div>
        </template>
      </Table>
    </b-card>
    <ApproveModal
        :text-content="modalText"
        :title="modalTitle"
        :action="modalAction"
        @ok="handleModalConfirm"
        @close="showModal = false"
    />
  </div>
</template>

<script>
import {
  BTable,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BPagination,
  BTr,
  BTh,
  BButton,
  BLink,
  BBadge,
} from "bootstrap-vue";
import CustomLoader from "@/components/Common/CustomLoader";
import Table from "@/components/Common/Table2";
import Ripple from "vue-ripple-directive";
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ClipboardJS from 'clipboard';
import ApproveModal from '@/components/Common/ApproveModal'

export default {
  components: {
    Table,
    BTable,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BPagination,
    BTr,
    BTh,
    BButton,
    BLink,
    CustomLoader,
    ApproveModal,
    BBadge,
  },
  directives: {
    Ripple,
  },
  computed: {
    rows() {
      return this.totalItems;
    },
  },
  data() {
    return {
      showCopiedTooltip: [],
      partner_name: null,
      percentage: null,
      discount: null,
      hive_fee: null,
      page: 1,
      totalItems: 0,
      tableKey: 0,
      referralProgram: [],
      url: '/referral-program',
      selected: 'none',
      fields: [
        {key: "name", label: "referrer_name"},
        {key: "collected_hive_fee_chf", label: "CHF"},
        {key: "collected_hive_fee_eur", label: "EUR"},
        {key: "collected_hive_fee_usd", label: "USD"},
        {key: "collected_hive_fee_gbp", label: "GBP"},
        {key: "code", label: "code"},
        {key: "companies", label: "referred_companies"},
        {key: "status", label: "status"},
        {key: "actions", label: "actions", aling: "end"},
      ],
      modalText: null,
      modalTitle: null,
      modalAction: null,
      modalItem: null,
      showModal: false,
    };
  },
  methods: {
    copyToClipboard(text, itemId) {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);

      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Copied!",
          icon: "CopyIcon",
          variant: "success",
        },
      });

      this.$set(this.showCopiedTooltip, itemId, true);
      setTimeout(() => {
        this.$set(this.showCopiedTooltip, itemId, false);
      }, 1000);
    },
    copyLink(item) {
      const codeToCopy = item.rrp_link;
      this.copyToClipboard(codeToCopy, item.id);
    },
    openModal(action, item) {
      this.modalAction = action
      this.modalItem = item
      this.modalTitle = action === 'confirm' ? this.$t('confirm') : this.$t('cancel')
      this.modalText = action === 'confirm' ? this.$t('are_you_sure_confirm_referral') : this.$t('are_you_sure_cancel_referral')
      this.$root.$bvModal.show('approveModal')
    },
    handleModalConfirm() {
      if (this.modalAction === 'confirm') {
        this.doConfirm(this.modalItem)
      } else if (this.modalAction === 'cancel') {
        this.doCancel(this.modalItem)
      }
      this.showModal = false
    },
    callApproveModalAction() {
      if (this.modalAction === 'confirm') {
        this.doConfirm(this.modalItem)
      } else if (this.modalAction === 'cancel') {
        this.doCancel(this.modalItem)
      }
    },
    doConfirm(item) {
      this.$http
          .post(`/referral-program/${item.id}/confirm`)
          .then((res) => {
            if (res) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "success",
                  icon: "SuccessIcon",
                  variant: "success",
                },
              });
              this.tableKey += 1;
            }
          });
    },
    doCancel(item) {
      this.$http
          .post(`/referral-program/${item.id}/cancel`)
          .then((res) => {
            if (res) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "success",
                  icon: "SuccessIcon",
                  variant: "success",
                },
              });
              this.tableKey += 1;
            }
          });
    },
    parseCompanies(companies) {
      if (typeof companies === 'string') {
        try {
          const arr = JSON.parse(companies);
          return Array.isArray(arr) ? arr : [];
        } catch (e) {
          return [];
        }
      }
      return Array.isArray(companies) ? companies : [];
    },
    amountIsNotEmpty(item) {
      return (
          item.collected_hive_fee_chf ||
          item.collected_hive_fee_eur ||
          item.collected_hive_fee_usd ||
          item.collected_hive_fee_gbp
      );
    },
    getReferrerName(item) {
      const company = item?.company;

      if (!company) {
        return 'Undefined';
      }

      if (company.name) {
        return company.name;
      }

      const firstName = company.main_contact_person?.name || '';
      const lastName = company.main_contact_person?.last_name || '';
      const fullName = `${firstName} ${lastName}`.trim();

      return fullName || 'Undefined';
    },
  },
};
</script>

<style scoped></style>
